/* Reskinned version of antd drawer with common props */
import { classNames } from "@/lib/utils";
import { SentryErrorBoundary } from "@components/error/SentryErrorBoundary";
import { ClipboardCopyIcon, LinkIcon, XIcon } from "@heroicons/react/outline";
import { Drawer as AntdDrawer } from "antd";
import styles from "./Drawer.module.css";
import IconButton from "@components/library/IconButton";

export type DrawerProps = React.ComponentProps<typeof AntdDrawer> & {
  id?: string;
  idType?: "session" | "flow" | "agent";
};

export const DRAWER_WIDTH = 736;

const Drawer = ({
  id,
  className,
  children,
  idType,
  closable,
  maskClosable,
  width = DRAWER_WIDTH,
  contentWrapperStyle,
  ...props
}: DrawerProps) => {
  return (
    <AntdDrawer
      // Don't put a dark mask over the rest of the page unless the `maskClosable` setting is enabled
      // – we want to be able to click on other rows.
      // If `close on click away` is desired, `props.maskClosable` is set to true, but this only works
      // if the mask itself is also enabled.
      mask={maskClosable}
      keyboard={false} // Escape is controlled in the parent.
      // If we don't destroy on close, some of the keyboard shortcuts will still be active.
      destroyOnClose
      closeIcon={<IconButton size={24} Icon={XIcon} styling="outline" />}
      closable={closable}
      width={width}
      contentWrapperStyle={contentWrapperStyle}
      headerStyle={{ backgroundColor: "transparent", padding: "0px 20px 0 0 " }}
      bodyStyle={{ padding: 0 }} // Leave spacing to rendered child
      style={{ outline: "none", maxWidth: "100vw" }} // Avoid focus-within outline appearing during transition
      className={classNames(styles.drawer, className)}
      {...props}
    >
      <SentryErrorBoundary>{children}</SentryErrorBoundary>
    </AntdDrawer>
  );
};

export default Drawer;
